import * as React from 'react';
import { FormState } from '../types';

interface Props {
  form: FormState;
  set: (patch: Partial<FormState>) => void;
}

export default function MatrixOptions({ form, set }: Props) {
  return (
    <section>
      <h2>Matrix Options</h2>
      <div className="row">
        <label>preference <span className="tip" title="How ORS scores routes for the matrix. 'fastest' = pure time optimization (won't over-prefer motorways). 'shortest' = pure distance. 'recommended' = ORS default (favors motorways for HGV).">ⓘ</span></label>
        <select
          value={form.mPreference}
          onChange={(e) => set({ mPreference: e.target.value })}
        >
          <option value="recommended">recommended</option>
          <option value="fastest">fastest</option>
          <option value="shortest">shortest</option>
        </select>
      </div>
      <div className="row">
        <label>sources (indices) <span className="tip" title="Zero-based comma-separated list of indices. Blank = all.">ⓘ</span></label>
        <input
          type="text" placeholder="all"
          value={form.mSources}
          onChange={(e) => set({ mSources: e.target.value })}
        />
      </div>
      <div className="row">
        <label>destinations (indices) <span className="tip" title="Zero-based comma-separated list. Blank = all.">ⓘ</span></label>
        <input
          type="text" placeholder="all"
          value={form.mDestinations}
          onChange={(e) => set({ mDestinations: e.target.value })}
        />
      </div>
      <div className="row">
        <label>metrics</label>
        <div className="grid2 checkboxes" style={{ marginTop: 4 }}>
          {['distance', 'duration'].map(m => (
            <label key={m}>
              <input
                type="checkbox"
                checked={!!form.metrics[m]}
                onChange={(e) => set({ metrics: { ...form.metrics, [m]: e.target.checked } })}
              /> {m}
            </label>
          ))}
        </div>
      </div>
      <div className="row">
        <label className="checkbox" title="Return snapped points (useful for debugging).">
          <input
            type="checkbox"
            checked={form.mResolve}
            onChange={(e) => set({ mResolve: e.target.checked })}
          /> resolve_locations
        </label>
      </div>
    </section>
  );
}

